<template>
<div>
    <div class="title">
        <h2 class="dp-inblock">수강신청 관리</h2>
        <button class="admin-btn-default float-right ml-10" @click="movePage('/admin/reg')">+ 수강신청 등록</button>
        <button class="admin-btn-default float-right" @click="exportCheckList()">수강신청 제작 체크리스트</button>
        <p class="w-100per">
            - <span class="txt-red">수강신청 명</span> : 클릭 시 해당 수강신청을 수정 할 수 있습니다. <br>
            - <span class="txt-red">프로그램 미리보기</span> : 학습자단 미리보기가 가능합니다. (수강 신청 기간이 아니더라도 미리보기 확인 가능합니다.)<br>
            - <span class="txt-red">삭제하기</span> : 본인이 만든 수강신청만 삭제 가능합니다.<br>
            - <span class="txt-red">프로그램 추가</span> : 수강신청 페이지의 프로그램 list를 확인할 수 있으며, 추가할 수 있습니다.<br>
            - <span class="txt-red">수강신청 복사</span> : 신청자/대기인원 외 모든 사항들이 똑같은 수강신청을 복사할 수 있습니다.
        </p>
    </div>

    <div class="w-100per mg-auto">
        <table class="admin-table-top table-auto">
            <thead>
                <tr>
                    <th width="200px">수강신청 기간</th>
                    <td width="*">
                        <itm-datepicker v-model="sugangStartDate" :parentDate="sugangStartDate" format="yyyy-MM-dd" :language="$store.state.ko"></itm-datepicker>~
                        <itm-datepicker v-model="sugangEndDate" :parentDate="sugangEndDate" class="w-30per" format="yyyy-MM-dd" :language="$store.state.ko"></itm-datepicker>
                    </td>
                    <th class="w-200px">Company</th>
                    <td>
                        <input type="text" v-model="companyName" class="w-100per" placeholder="회사명을 입력해 주세요">
                    </td>
                </tr>
                <tr>
                    <th class="w-200px">수강신청 명</th>
                    <td colspan="3">
                        <input type="text" v-model="sugangName" class="w-100per" placeholder="수강신청 명을 입력해 주세요">
                    </td>
                </tr>
            </thead>
        </table>
        <div class="mt-10 float-right dp-block"><button class="admin-btn-default" @click="search()">검색</button></div>
    </div>

    <div class="con w-100per mg-auto">
        <div class="state-box dp-inblock mt-50 w-100per">
            <button class="admin-btn-danger" @click="delProgram()">삭제하기</button>
            <select v-model="selectHqManager" @change="changeHQManager(selectHqManager)" name="" id="" class="w-150px h-40px ml-05 mr-05">
                <option value="-1">전체</option>
                <option v-for="(item, index) of hqManagers" :key="index" :value="item">{{item.name}}</option>
            </select>
            <select v-model="status" @change="search()" name="" id="" class="w-100px h-40px mr-05">
                <option value="">전체</option>
                <option value="예정">예정</option>
                <option value="진행중">진행중</option>
                <option value="종료">종료</option>
            </select>
            <p class="dp-inblock ml-10">
                <label for="group">
                    <input type="checkbox" v-model="isGroup" @change="search()" name="group" id="">
                    <span class="font-13 ml-10">Group</span>
                </label>
            </p>
            <label for="Languagelab" class="ml-10">
                <input type="checkbox" v-model="isLab" @change="search()" name="Languagelab" id="">
                <span class="font-13 ml-10">1:1 Language Lab</span>
            </label>
            <label for="special">
                <input type="checkbox" class="ml-10" v-model="isUntact" @change="search()" name="Untact" id="">
                <span class="font-13  ml-10">Untact</span>
            </label>
            <label for="special">
                <input type="checkbox" class="ml-10" v-model="isSpecial" @change="search()" name="Special" id="">
                <span class="font-13  ml-10">특강</span>
            </label>
            <label for="special">
                <input type="checkbox" class="ml-10" v-model="isEtc" @change="search()" name="etc" id="">
                <span class="font-13  ml-10">기타</span>
            </label>
        </div>

        <div class="mt-20">
            <table class="admin-table-col mt-10 txt-center">
                <thead>
                    <tr>
                        <th style="width: 30px;"><input type="checkbox" v-model="allSelected" @change="allSelect()" name="" id=""></th>
                        <th style="width: 50px;">No</th>
                        <th style="width: 100px;">Company</th>
                        <th style="width: 105px;">프로그램</th>
                        <th style="width: 330px;">수강신청 명</th>
                        <th style="width: 160px;">수강신청 기간</th>
                        <th style="width: 130px;">HQ매니저</th>
                        <th style="width: 50px;">상태</th>
                        <th style="width: 60px;">미리보기</th>
                        <th style="width: 60px;">신청자</th>
                        <th style="width: 80px;">프로그램<br>추가</th>
                        <th style="width: 80px;">수강신청<br>복사</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) of sugangList" :key="index">
                        <td><input v-model="item.selected" @change="watchSelected()" type="checkbox" name="" id=""></td>
                        <td>{{listLength - (50 * (pageNum - 1)) - index}}</td>
                        <td class="break-all">{{item.companyNameDirect}}</td>
                        <td class="break-all">{{formatProgramType(item.programType)}}</td>
                        <td class="pointer txt-blue break-all" @click="loadSugang(item.idxItmSugangPageMain, item.programIdx)">{{item.sugangName}}</td>
                        <td v-if="item.sugang_always_signup_YN != 'Y'">{{item.sugangStartDate.slice(0, 10)}} ~ {{item.sugangEndDate.slice(0, 10)}}</td>
                        <td v-else>상시 신청</td>
                        <td>{{item.hqNameMng || '-'}}</td>
                        <td>{{item.status || '-'}}</td>
                        <td class="txt-blue pointer" @click="preview(item.companyCode)"><i class="fas fa-search"></i></td>
                        <td class="txt-blue pointer" @click="moveApplyList(item.idxItmSugangPageMain, item.sugangName)"><span class="bold">view</span></td>
                        <!-- <td class="txt-blue pointer" @click="moveApplyList(item.idxItmSugangPageMain, item.programName)"><span class="bold">{{item.totalWaitNum}}</span>/{{item.totalWaitingNum}}</td> -->
                        <td class="txt-blue pointer" @click="moveFixProgram(item.idxItmSugangPageMain, item.sugangName)">+ 추가</td>
                        <td class="txt-blue pointer" @click="copy(item.idxItmSugangPageMain)">복사</td>
                    </tr>
                    <!-- 리스트에 내용이 없을 경우 -->
                    <tr v-if="listLength === 0">
                        <td colspan="12" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
                    </tr>
                </tbody>
            </table>

            <div class="paging mt-30">
                <ul>
                    <li>
                        <a class="pointer" @click="prevPaging()"> &lt; </a>
                    </li>
                    <li v-for="index in calcMaxPaging()" :key="index" class="txt-blue">
                        <span class="pointer" style="padding: 8px;" @click="paging(index)">
                            <a :class="{'carrot-active bold': index === pageNum}">{{index}}</a>
                        </span>
                    </li>
                    <li>
                        <a class="pointer" @click="nextPaging()"> &gt; </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/utils/grid.button.js'
export default {
    data: () => ({
        companyName: '', // 회사명
        hqIdx: '', // 검색쿼리 HQ매니저 idx
        loginIdxItmSugangEmpMng: '', // 현재 로그인한 HQ매니저 idx
        pageNum: 1, // 현재 페이지 넘버
        pageSize: 50, // 페이징 사이즈 (default: 50)
        status: '', // 상태 (전체 : '', 대기: Y, 신청완료: N, 신청취소: C)
        sugangName: '', // 수강신청 명
        sugangStartDate: '', // 수강신청 검색 시작일
        sugangEndDate: '', // 수강신청 검색 종료일
        sugang_always_signup_YN : '',//수강신청 상시여부

        hqManagers: [], // HQ매니저 전체 리스트 정보
        selectHqManager: {}, // 선택된 HQ 담당자 정보

        sugangList: [], // 수강신청 리스트
        listLength: 0, // 수강신청 리스트 size

        maxPagingCount: 1, // 최대 페이지 수
        maxPagePart: 1, // 최대 파트가 몇번째인지
        pagePart: 1, // 현재 페이징이 몇번째 파트에 있는지 (ex 1~10 1파트, 11~20 2파트)

        allSelected: false, // 전체 체크

        isGroup: false, // 그룹수업
        isLab: false, // 1:1 Language Lab
        isUntact: false, // 언택
        isSpecial: false, // 특강
        isEtc: false, // 기타
        isValidSession: true,

        hqManager: 'all'
    }),

    mounted() {
        // 1시간 내로 한번씩 캐시 초기화를 시켜준다.
        if (localStorage.getItem('refreshDate')) {
            var oldTime = Number(localStorage.getItem('refreshDate'))
            var newTime = new Date().getTime()
            if ((newTime - oldTime) > 3600000) {
                localStorage.setItem('refreshDate', new Date().getTime())
                location.reload(true)
            }
        } else {
            localStorage.setItem('refreshDate', new Date().getTime())
            location.reload(true)
        }
        const {startDtToStr, endDtToStr} = this.setDate();
        this.sugangStartDate = startDtToStr;
        this.sugangEndDate = endDtToStr;

        this.getSessionSearch();
        this.loginIdxItmSugangEmpMng = localStorage.getItem('regid');
        this.asyncSearch()
    },
    methods: {
        // 체크리스트 다운로드
        exportCheckList() {
            window.open('https://kr.object.ncloudstorage.com/itmsugang/excel/checklist.xlsx')
        },

        // 수강신청 복사
        copy(pageIdx) {
            var params = {
                pageIdx: pageIdx
            }

            this.axios.post(this.axios.root + this.axios.port + `/admin/sugang-copy/${pageIdx}`, params).then(res => {
                alert('복사되었습니다.')
                this.search()
            }).catch(err => {
                console.log(err)
                alert(err)
            })
        },

        // 미리보기 => AccessCode 학습자단으로 넘어감
        preview(companyCode) {
            if (companyCode) {
                // window.open(`http://localhost:8081/lnk/${companyCode}`)
                window.open(this.axios.preview + `/link/${companyCode}`)
            } else {
                alert('미리보기가 불가능한 페이지입니다.')
                return false
            }
        },

        // 리스트 체크박스 전체선택 / 전체해제
        allSelect() {
            for (var item of this.sugangList) {
                item.selected = this.allSelected
            }
        },

        // 체크박스 전체선택/전체해제시 테이블의 전체 체크박스 on/off 위함
        watchSelected() {
            var count = 0
            for (var item of this.sugangList) {
                if (item.selected === true) {
                    count += 1
                }
            }

            if (count === this.sugangList.length) {
                this.allSelected = true
            } else {
                this.allSelected = false
            }
        },

        // 수강신청 프로그램 삭제하기
        async delProgram() {
            var count = 0
            var deleteIdxs = []
            for (var item of this.sugangList) {
                if (item.selected === true) {
                    deleteIdxs.push(item.idxItmSugangPageMain)
                    count += 1
                }
            }

            if (count === 0) {
                alert('삭제하실 프로그램을 선택해주세요.')
                return false
            }

            var con_test = confirm("선택하신 리스트를 삭제하시겠습니까?");
            if (con_test == true) {

                var params = new URLSearchParams()
                params.append('pageIdx', deleteIdxs.join('/'))

                await this.axios.put(this.axios.root + this.axios.port + '/admin/sugang-program-delete', params)
                    .then(res => {
                        if (res.data.err === 0) {
                            alert('선택한 수강신청이 삭제되었습니다.')
                            this.search()
                        } else {
                            alert(res.data.result)
                        }
                    })
            } else {
                return false;
            }
        },

        // 이전 페이징
        prevPaging() {
            if (this.pageNum === 1) {
                return false;
            } else {
                this.pageNum -= 1;
                this.search();
            }
        },

        paging(index) {
            this.pageNum = index;
            this.search();
        },

        // 현재 페이지의 페이지 범위 계산
        calcMaxPaging() {
            if (this.maxPagingCount > this.pagePart * 10) {
                this.maxPagePart = this.pagePart * 10
            } else {
                this.maxPagePart = this.maxPagingCount
            }
            var pagingArray = []
            for (var i = ((this.pagePart - 1) * 10) + 1; i <= this.maxPagePart; i++) {
                pagingArray.push(i)
            }
            return pagingArray
        },

        // 다음 페이징
        nextPaging() {
            if (this.pageNum === this.maxPagingCount) {
                return false
            } else {
                this.pageNum += 1
                this.search()
            }
        },

        // HQ Manager을 먼저 호출하고 1:1 리스트를 호출하기 위해 async함수 추가
        async asyncSearch() {
            await this.fetchHQList()
            await this.search()
        },

        // HQList api 호출
        async fetchHQList() {
            await this.axios.get(this.axios.root + this.axios.port + '/admin/list')
                .then(res => {
                    if (res.data.err === 0) {
                        this.hqManagers = res.data.hqList;
                        if(this.hqIdx){
                            const find = this.hqManagers.find(item => Number(item.regid) === Number(this.hqIdx));
                            if(find){
                                this.selectHqManager = find;
                            }
                            else{
                                this.selectHqManager = -1;
                            }
                        }
                        else{
                            for (var manager of this.hqManagers) {
                                if (manager.regid === Number(this.loginIdxItmSugangEmpMng)) {
                                    this.idxItmSugangEmpMng = Number(this.loginIdxItmSugangEmpMng);
                                    this.selectHqManager = manager;
                                    this.hqIdx = this.idxItmSugangEmpMng;
                                }
                            }
                        }
                        
                    } else if (res.data.err === 401) {
                        alert(res.data.result)
                        this.isValidSession = false
                        this.$router.push('/admin/login')
                    } else {
                        alert(res.data.result)
                    }
                }).catch(err => {
                    console.log('err', err)
                    alert('세션이 만료되어 로그인 창으로 이동합니다.')
                    this.$router.push('/admin/login')
                })
        },

        // 수강신청 리스트 api 호출
        async search() {
            // 세션 끊겼을 시에 로그아웃
            if (!this.isValidSession) {
                return false
            }

            var params = {
                companyName: this.companyName,
                hqIdx: this.hqIdx,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                status: this.status,
                sugangName: this.sugangName,
            }

            // group, 1:1lab, 특강 검색
            if (this.isLab) {
                params['programType'] = 'L'
            } else if (this.isGroup) {
                params['programType'] = 'G'
            } else if (this.isSpecial) {
                params['programType'] = 'S'
            } else if (this.isUntact) {
                params['programType'] = 'U'
            } else if (this.isEtc) {
                params['programType'] = 'E'
            }

            if (typeof this.sugangStartDate === 'object') {
                params['sugangStartDate'] = this.sugangStartDate.toISOString().slice(0, 10)
            } else {
                params['sugangStartDate'] = this.sugangStartDate
            }

            if (typeof this.sugangEndDate === 'object') {
                params['sugangEndDate'] = this.sugangEndDate.toISOString().slice(0, 10)
            } else {
                params['sugangEndDate'] = this.sugangEndDate
            }

            //검색조건 sessionStorage에 저장
            this.saveSearch(params);

            await this.axios.get(this.axios.root + this.axios.port + '/admin/sugang-list', {
                params: params
            }).then(res => {
                if (res.data.err === 0) {
                    this.sugangList = res.data.sugangList
                    if (res.data.sugangListSize) {
                        this.listLength = res.data.sugangListSize
                    }
                    this.maxPagingCount = Math.ceil(this.listLength / this.pageSize)
                    this.maxPagePart = Math.ceil(this.maxPagingCount / 10)
                    this.pagePart = Math.ceil(this.pageNum / 10)
                } else if (res.data.err === 105) {
                    this.sugangList = []
                    this.listLength = 0
                    this.maxPagingCount = Math.ceil(this.listLength / this.pageSize)
                    this.maxPagePart = Math.ceil(this.maxPagingCount / 10)
                    this.pagePart = Math.ceil(this.pageNum / 10)
                } else {
                    alert(res.data.result)
                }
            })
        },

        // programType 포맷 변환
        formatProgramType(type) {
            var types = [];
            var charType = '';
            if (type.length > 1) {
                types = type.split(',')
                charType = types[0]
                return this.switchProgramType(charType) + ' 외 ' + (types.length-1) + '건'
            } else {
                charType = type
                return this.switchProgramType(charType)
            }
        },

        switchProgramType(charType) {
            switch (charType) {
                case 'G':
                    return 'Group'
                case 'L':
                    return '1:1 Language Lab'
                case 'U':
                    return 'Untact'
                case 'S':
                    return '특강'
                case 'E':
                    return '기타'
                default:
                    return '-'
            }
        },

        // HQ매니저 select 변경시 idx 같이 변경
        changeHQManager(data) {
            if (data !== '-1') {
                this.hqIdx = data.regid;
            } else {
                this.hqIdx = -1;
            }

            this.search();
        },

        // 오늘 날짜 YYYY-MM-DD로 지정하는 함수
        formatDate() {
            var d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            return [year, month, day].join('-');
        },

        // 페이지 이동
        movePage(path) {
          sessionStorage.removeItem("fix");
          sessionStorage.removeItem('pageIdx')
          this.$router.push(path)
        },

        // 수강신청 불러오기
        async loadSugang(pageIdx, programIdx) {
            await this.axios.get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`)
                .then(res => {
                    if (res.data.err === 0) {
                        sessionStorage.setItem('category', res.data.pageInfo.category)
                        var pOrder = []
                        for (var i = 1; i <= 8; i++) {
                            for (var item of res.data.menu) {
                                if (item.order === i.toString()) {
                                    if (item.status === 'Y') {
                                        if (item.name === 'summary') {
                                            pOrder.push('input')
                                        } else if (item.name === 'agree') {
                                            pOrder.push('agree')
                                        } else if (item.name === 'guide') {
                                            pOrder.push('info')
                                        } else if (item.name === 'choose') {
                                            pOrder.push('enroll')
                                        } else if (item.name === 'info') {
                                            pOrder.push('userInfo')
                                        } else if (item.name === 'pay') {
                                            pOrder.push('purchase')
                                        } else if (item.name === 'complete') {
                                            pOrder.push('complete')
                                        } else if (item.name === 'popup') {
                                            pOrder.push('setPopup')
                                        }
                                    }
                                }
                            }
                        }

                        sessionStorage.setItem('pOrder', JSON.stringify(pOrder))
                        sessionStorage.setItem('pageIdx', pageIdx)
                        sessionStorage.setItem('programIdx', programIdx)
                        sessionStorage.setItem('fix', true)
                        sessionStorage.setItem('step', 'input')
                    }
                })
            await this.$router.push('/admin/reg/input')
        },

        setOrder(category) {
            if (category === 'A') {
                this.progressOrder = ['input', 'agree', 'info', 'enroll', 'userInfo', 'purchase', 'complete', 'setPopup']
            } else if (category === 'B') {
                this.progressOrder = ['input', 'agree', 'enroll', 'info', 'userInfo', 'purchase', 'complete', 'setPopup']
            } else {
                this.progressOrder = ['input', 'agree', 'userInfo', 'info', 'enroll', 'purchase', 'complete', 'setPopup']
            }
            sessionStorage.setItem('pOrder', JSON.stringify(this.progressOrder))
        },

        // 신청자 리스트 페이지 이동
        moveApplyList(pageIdx, programName) {
            if (programName) {
                sessionStorage.setItem('programName', programName)
                this.$router.push(`/admin/list/applyList?pageIdx=${pageIdx}`)
            } else {
                alert('등록된 프로그램이 없습니다.')
            }
        },

        // 프로그램 추가/삭제 페이지 이동
        moveFixProgram(pageIdx, programName) {
            sessionStorage.setItem('programName', programName)
            this.$router.push(`/admin/list/fixProgram?pageIdx=${pageIdx}`)
        },

        /**
         * @description : 검색조건 sessionStorage에 저장
         */
        saveSearch(params){
            const copyParams = {
                companyName: params.companyName,
                hqIdx: params.hqIdx,
                pageNum: params.pageNum,
                pageSize: params.pageSize,
                status: params.status,
                sugangName: params.sugangName,
                isLab: this.isLab,
                isGroup: this.isGroup,
                isSpecial: this.isSpecial,
                isUntact: this.isUntact,
                isEtc: this.isEtc,
                sugangStartDate: params.sugangStartDate,
                sugangEndDate: params.sugangEndDate,
            }
            sessionStorage.setItem('searchRequirement', JSON.stringify(copyParams));
        },

        /**
         * @description : sessionStorage get
         */
        getSessionSearch(){
            const searchObj = JSON.parse(sessionStorage.getItem('searchRequirement'));

            for(let keyName in searchObj){
                if(searchObj[keyName]){
                   this.settingSearch(keyName, searchObj[keyName])
                }
            }
        },

        
        /**
         * @description : 검색조건 세팅
         * @param keyName : 키명
         * @param value : 키 값
         */
        settingSearch(keyName, value){
            if(keyName === 'companyName'){
                this.companyName = value;
            }
            else if(keyName === 'hqIdx'){
                this.hqIdx = value;
            }
            else if(keyName === 'pageNum'){
                this.pageNum = value;
            }
            else if(keyName === 'pageSize'){
                this.pageSize = value;
            }
            else if(keyName === 'status'){
                this.status = value;
            }
            else if(keyName === 'sugangName'){
                this.sugangName = value;
            }
            else if(keyName === 'isLab'){
                this.isLab = value;
            }
            else if(keyName === 'isGroup'){
                this.isGroup = value;
            }
            else if(keyName === 'isSpecial'){
                this.isSpecial = value;
            }
            else if(keyName === 'isUntact'){
                this.isUntact = value;
            }
            else if(keyName === 'isEtc'){
                this.isEtc = value;
            }
            else if(keyName === 'sugangStartDate'){
                this.sugangStartDate = value;
            }
            else if(keyName === 'sugangEndDate'){
                this.sugangEndDate = value;
            }
        },

        /**
         * @description : 올해년도 세팅
         */
        setDate(){
            const now = new Date();
            const startDate = new Date(now.getFullYear(), 0,1);
            const endDate = new Date(now.getFullYear(), 12,0);

            const startDtToStr = this.formatYyyyMmDd(startDate);
            const endDtToStr = this.formatYyyyMmDd(endDate);

            return {startDtToStr, endDtToStr}
        },

        formatYyyyMmDd(date){
            const yyyy = date.getFullYear();
            const mm = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
            const dd = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;

            return `${yyyy}-${mm}-${dd}`;
        }
        
    }
}
</script>